import { ON_SETTINGS_CHANGE } from '../../../actions/utils';

export default (state = [], action) => {
  const settingsObj =
    action.type === ON_SETTINGS_CHANGE ? { ...action.payload } : state;

  settingsObj.isArrowExpandIcon =
    settingsObj.openQuestionIcon ===
    window.initialState.constants.QUESTION_OPEN_ICON.ARROW;
  settingsObj.isRegularAppSpacing =
    settingsObj.spaces === window.initialState.constants.SPACES.LOOSE;
  settingsObj.isDemoFaqData = false;
  settingsObj.isRTL =
    settingsObj.textAlignment === window.initialState.constants.ALIGNMENT.RIGHT;
  settingsObj.isBasic =
    settingsObj.layout === window.initialState.constants.LAYOUT.BASIC;
  settingsObj.isCollapse =
    settingsObj.layout === window.initialState.constants.LAYOUT.COLLAPSE;
  settingsObj.isStripes =
    settingsObj.layout === window.initialState.constants.LAYOUT.STRIPES;

  settingsObj.isDisplayCategoriesTop =
    settingsObj.isBasic &&
    settingsObj.displayCategories ===
      window.initialState.constants.DISPLAY_CATEGORIES.TOP;

  settingsObj.direction = settingsObj.isRTL ? 'rtl' : 'ltr';
  settingsObj.isFixedHeight =
    settingsObj.heightApp === window.initialState.constants.HEIGHT_APP.FIXED;
  const viewClass = settingsObj.layout + '-colors';
  const alignmentClass = 'alignment-' + settingsObj.textAlignment;
  settingsObj.mainClassesName =
    'container ' + viewClass + ' ' + alignmentClass + ' ' + settingsObj.spaces;
  settingsObj.spacesPixcel =
    settingsObj.spaces === window.initialState.constants.SPACES.TIGHT ? 0.5 : 1;
  settingsObj.lineHeightPixcel = settingsObj.spacesPixcel === 1 ? 40 : 30;
  settingsObj.isNewApp =
    typeof settingsObj.mobile !== 'undefined' &&
    settingsObj.mobile.titleFontSize > 0;

  return settingsObj;
};
